import { getBaseCurrency } from "../currency";

// Default currency is the store base ('gbp' until multi-currency is enabled
// and seeded — see src/core/currency.js — so legacy output is unchanged).
export const moneyFormatter = (amount, currency) => {
  currency = currency || getBaseCurrency();
  if (currency === "usdt") {
    currency = "usd";
  }
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
  });

  return formatter.format(amount);
};

export const conditionFormatter = (condition) => {
  if (!condition) return null;

  const result = (Array.isArray(condition) ? condition : [condition])
    ?.map((cond) => {
      switch (cond) {
        case "new":
          return "New";
        case "excellent":
          return "Excellent";
        case "very-good":
          return "Very Good";
        case "good":
          return "Good";
        case "fair":
          return "Fair";
        default:
          "-";
      }
    })
    .join(", ");

  return result;
};

/**
 * Scroll to a specific request element by ID and expand its dropdown
 * @param {string} requestId - The ID of the request to scroll to
 * @param {number} delay - Delay in milliseconds before scrolling (default: 500)
 */
export const scrollToRequest = (requestId, delay = 500) => {
  setTimeout(() => {
    const selectors = [
      `[data-request-id="${requestId}"]`,
      `[data-item-id="${requestId}"]`,
      `#request-${requestId}`,
      `.order-item[data-id="${requestId}"]`
    ];
    
    let element = null;
    for (const selector of selectors) {
      element = document.querySelector(selector);
      if (element) break;
    }
    
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
      
      const collapsibleTriggers = element.querySelectorAll('.collapsible__trigger');
      collapsibleTriggers.forEach(trigger => {
        const collapsible = trigger.closest('.collapsible');
        if (collapsible && !collapsible.classList.contains('collapsible--open')) {
          setTimeout(() => {
            trigger.click();
          }, 100);
        }
      });
      
      const quoteTriggers = element.querySelectorAll('[data-testid="quotes-trigger"], .quotes-trigger');
      quoteTriggers.forEach(trigger => {
        const quotesSection = trigger.closest('.quotes-section, .collapsible');
        if (quotesSection && !quotesSection.classList.contains('collapsible--open')) {
          setTimeout(() => {
            trigger.click();
          }, 200); 
        }
      });
    }
  }, delay);
};
